import { useState } from "react";

export function useSettingsData(supabase, landlordId, reload) {
  const [settings, setSettings] = useState({
    landlordName: "", landlordEmail: "", landlordPhone: "",
    propertyName: "", propertyAddress: "",
    lateFeeEnabled: false, lateFeeGraceDays: 5, lateFeeAmount: 50, dueDayOfMonth: 1,
    pass_fee_to_tenant: false,
  });
  const [settingsSaved, setSettingsSaved] = useState(false);

  const [companyProfile, setCompanyProfile] = useState({ company_name: "", dba: "", email: "", phone: "", address: "", website: "", invoice_prefix: "INV", invoice_counter: 1000, invoice_footer: "", logo_url: "" });
  const [companyProfileSaved, setCompanyProfileSaved] = useState(false);
  const [logoSaved, setLogoSaved] = useState(false);

  const saveSettings = async (overrides = {}, quiet = false) => {
    const merged = { ...settings, ...overrides };
    const savePayload = {
      ...(merged.id ? { id: merged.id } : {}),
      user_id: landlordId,
      landlordName: merged.landlordName, landlordEmail: merged.landlordEmail,
      landlordPhone: merged.landlordPhone, propertyName: merged.propertyName,
      propertyAddress: merged.propertyAddress, lateFeeEnabled: merged.lateFeeEnabled,
      lateFeeGraceDays: merged.lateFeeGraceDays, lateFeeAmount: merged.lateFeeAmount,
      dueDayOfMonth: merged.dueDayOfMonth,
      pass_fee_to_tenant: merged.pass_fee_to_tenant ?? false,
    };
    const { error } = await supabase.from("settings").upsert(savePayload, { onConflict: "id" });
    if (error) { alert("Error saving settings: " + error.message); return; }
    if (!quiet) {
      setSettingsSaved(true);
      setTimeout(() => setSettingsSaved(false), 3000);
    }
  };

  const saveCompanyProfile = async () => {
    let logo_url = companyProfile.logo_url || null;
    const hadLogoFile = !!companyProfile.logoFile;

    if (companyProfile.logoFile) {
      const file = companyProfile.logoFile;
      console.log("[saveCompanyProfile] sending logo to upload-company-logo function:", file.name, file.size);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("landlordId", landlordId);
      const { data: fnData, error: fnError } = await supabase.functions.invoke("upload-company-logo", { body: formData });
      const uploadErrMsg = fnData?.error || fnError?.message;
      if (uploadErrMsg) {
        console.error("[saveCompanyProfile] logo upload error:", uploadErrMsg);
        alert("Logo upload failed: " + uploadErrMsg);
        return;
      }
      logo_url = fnData.url;
      console.log("[saveCompanyProfile] logo public URL:", logo_url);
    }

    const payload = {
      user_id: landlordId,
      company_name: companyProfile.company_name || null,
      dba: companyProfile.dba || null,
      email: companyProfile.email || null,
      phone: companyProfile.phone || null,
      address: companyProfile.address || null,
      website: companyProfile.website || null,
      invoice_prefix: companyProfile.invoice_prefix || "INV",
      invoice_footer: companyProfile.invoice_footer || null,
      logo_url,
    };
    console.log("[saveCompanyProfile] upserting company_profiles:", payload);
    const { error } = await supabase.from("company_profiles").upsert(payload, { onConflict: "user_id" });
    if (error) {
      console.error("[saveCompanyProfile] upsert error:", error);
      alert("Error saving company profile: " + error.message);
      return;
    }
    setCompanyProfile(s => ({ ...s, logo_url, logoFile: null }));
    setCompanyProfileSaved(true);
    setTimeout(() => setCompanyProfileSaved(false), 3000);
    if (hadLogoFile) {
      setLogoSaved(true);
      setTimeout(() => setLogoSaved(false), 3000);
    }
    reload();
  };

  return {
    settings, setSettings, settingsSaved,
    companyProfile, setCompanyProfile, companyProfileSaved, logoSaved,
    saveSettings, saveCompanyProfile,
  };
}
